import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Typography,
  } from "@mui/material";
  import MyButton from "./myButton"; 
  
  const RemoveDeviceConfirmationBoxWeb = ({ openRemoveDialog, onCloseRemoveDialog, onConfirmRemove, device }) => {
    return (
      <Dialog
        open={openRemoveDialog}
        onClose={() => onCloseRemoveDialog(false)}
        aria-labelledby="remove-device-dialog-title"
        aria-describedby="remove-device-dialog-description"
        PaperProps={{
          style: {
            backgroundColor: "#1a1c24",
            color: "white",
            padding: "20px",
            borderRadius: "12px",
            position: "relative",
          },
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={() => onCloseRemoveDialog(false)}
          sx={{ position: "absolute", top: 10, right: 10, color: "white" }}
        >
          <i className="fa fa-times" style={{ fontSize: "24px" }}></i>
        </IconButton>
  
        {/* Icon */}
        <div
          style={{
            textAlign: "center",
            marginTop: "20px",
            marginBottom: "10px",
          }}
        >
          <div
            style={{
              background: "#2a2c35",
              borderRadius: "20px",
              width: "64px",
              height: "64px",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <i className="fa fa-trash" style={{ fontSize: "32px", color: "#e20074" }}></i>
          </div>
        </div>
  
        {/* Title */}
        <DialogTitle id="remove-device-dialog-title" sx={{ textAlign: "center" }}>
          <Typography variant="h6" fontWeight="bold">
            Remove Device
          </Typography>
        </DialogTitle>
  
        {/* Description */}
        <DialogContent>
          <DialogContentText
            id="remove-device-dialog-description"
            sx={{ textAlign: "center", color: "#a0a0a0" }}
          >
            Are you sure you want to remove {device?.deviceName} ?
          </DialogContentText>
        </DialogContent>
  
        {/* Action Buttons */}
        <DialogActions sx={{ justifyContent: "center", padding: "16px" }}>
          <MyButton
            title="Cancel"
            openExitDialogue={() => onCloseRemoveDialog(false)}
            style={{ backgroundColor: "#2c2f39", color: "#fff" }}
          />
          <MyButton
            title="Remove"
            openExitDialogue={() => onConfirmRemove(device)}
            style={{
              background: "linear-gradient(to right, #ff4d4d, #e20074)",
              color: "white",
            }}
          />
        </DialogActions>
      </Dialog>
    );
  };
  
  export default RemoveDeviceConfirmationBoxWeb;
  